import OrderStatusEnum from '@/app-core/api/enums/OrderStatusEnum'

export default {
  name  : 'orderCommon',
  mixins: [],
  data() {
    return {}
  },
  computed: {},
  methods : {
    ordersCompleted(orders, statusIdField = 'StatusId') {
      return orders?.every(order => order[statusIdField] === OrderStatusEnum.Completed || order[statusIdField] === OrderStatusEnum.Canceled)
    }
  }
}
